"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("@emotion/react");
const b_1 = __importDefault(require("b_"));
const branding_1 = require("src/context/branding");
const logo_styles_1 = __importDefault(require("./logo.styles"));
const b = b_1.default.with('logo');
function Logo({ withHeader }) {
    const { logo: { imgSrc = '' } = {} } = (0, branding_1.useBrandingContext)() || {};
    if (!imgSrc) {
        return null;
    }
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(react_1.Global, { styles: logo_styles_1.default }), (0, jsx_runtime_1.jsx)("div", Object.assign({ className: b({ withHeader }) }, { children: (0, jsx_runtime_1.jsx)("img", { src: imgSrc }) }))] }));
}
exports.default = Logo;
